import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { UploaddocumentService } from '../services/uploaddocument/uploaddocument.service';
import { ToastrService } from 'ngx-toastr';
import { LoggerService } from '../services/logger/logger.service';
import { map, tap } from 'rxjs/operators';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { NewRegistrationDataCollectionService } from '../services/registration/newRegistration-data-collection.service';
import { RegistrationModel } from 'src/app/registrations-data/models/data/registration.model';
import { Document } from '../../models/document.model';

@Component({
  selector: 'app-uploaddocument',
  templateUrl: './uploaddocument.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class UploaddocumentComponent implements OnInit {

  @Input()
  documentTypeCode: string;
  @Input()
  docTypeDescription: string;
  @Input()
  documentID: string;
  @Input()
  reg: RegistrationModel;
  @Input()
  isEditable: boolean;
  @Input()
  isRequired: boolean;

  registrationForm$: Observable<RegistrationModel> = this.dataCollectionSvc.regFormObserv;
  showDelete: boolean;
  file: File;
  FileName = '';

  private downloadActionSubject = new Subject<boolean>();
  downloadActionStream: Observable<boolean> = this.downloadActionSubject.asObservable();
  enableUpload: boolean;
  uploading = false;
  private alreadyHaveAttachmentForDocType: boolean = false;
  private haveExistingAttachForTypeSubject = new BehaviorSubject<boolean>(this.alreadyHaveAttachmentForDocType);
  existingAttachAlreadyPresentDataStream = this.haveExistingAttachForTypeSubject.asObservable();


  constructor(
    private toastrService: ToastrService,
    private uploaddocumentService: UploaddocumentService, private loggerService: LoggerService,
    private dataCollectionSvc: NewRegistrationDataCollectionService
  ) {
  }

  postedFileDataStream = this.uploaddocumentService.postFile$.pipe(
    tap(x => console.log('Reg buildin\' posted file: ', x)),
    tap(resp => {
      this.uploading = false;
      this.documentID = resp.documentId;
      const attachmnt: Document = new Document();
      attachmnt.documentId = resp.documentId;
      attachmnt.documentType.code = resp.documentType.code;
      attachmnt.fileName = resp.fileName;
      // COMMENTD THIS CODE AS IT IS NOT HANDLED AS PER NEW DOCUMENT MODEL;
      if (!this.reg.documents) {
        this.reg.documents = new Array<Document>();
      }
      this.reg.documents.push(attachmnt);
      this.haveExistingAttachForTypeSubject.next(true);
    })
  );

  downloadedFileDataStream = this.uploaddocumentService.getDocument$.pipe(
    map((res: any) => {
      const blob = new Blob([res], { type: res.type });
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
    }
    )
  );

  setDownloadAction(wantToDownload: boolean) {
    this.downloadActionSubject.next(wantToDownload);
  }

  ngOnInit() {
    if (this.reg.documents && this.reg.documents.find(x => x.documentType.code === this.documentTypeCode)) {
      const attach: Document = this.reg.documents.find(x => x.documentType.code === this.documentTypeCode);
      if (attach) {
        this.documentID = attach.documentId;
        this.haveExistingAttachForTypeSubject.next(true);
      } else {
        this.haveExistingAttachForTypeSubject.next(false);
      }
    }
  }

  fileChange(event) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.file = fileList[0];
      this.FileName = this.file.name;
    }
  }


  Upload() {
    this.uploading = true;
    this.uploaddocumentService.postDocument(this.documentTypeCode, this.file);
    this.showDelete = true;
  }


  ondocumentListClicked(data) {
    switch (data.colDef.field) {
      case 'view': {
        this.uploaddocumentService.setDocumentID(data.data.docID);
        return this.uploaddocumentService.getDocument$;
        break;
      }
      case 'delete': {
          this.uploaddocumentService.delete(data.data.docID);
          this.uploaddocumentService.deleteDocument$.pipe(
            map(() => this.GetDocumentList())
          );
          break;
      }
    }
  }
  // Not sure if this is relevant any more for this component since it is only responsible for one doc type at a time but they
  // might want to upload multiple documents for one type like multiple pictures to give proof of a lease
  // If we need to get a list of docs for an overall registration then another component should take care of that
  GetDocumentList() {
    // this doesn't make sense to use the same set doc method for either an id or a type.  might need to get all docs for a
    // particular type but that should be a different svc feature than off of doc id
    this.uploaddocumentService.setDocumentID(this.documentTypeCode);
    this.uploaddocumentService.getDocuments$.pipe(
      map(
        (data: any) => {
          if (data) {
            if (data.StatusMessage && data.StatusMessage.includes('not found')) {

            } else {

            }
          }
        },
      )
    );
  }

  onViewClick() {
    this.setDownloadAction(true);
    this.uploaddocumentService.setDocumentID(this.documentID);
  }


  onDeleteClick() {
      this.uploaddocumentService.delete(this.documentID);
      const deleteDocumentSubscription = this.uploaddocumentService.deleteDocument$.subscribe(value => {
        deleteDocumentSubscription.unsubscribe();
        this.toastrService.success('File was deleted successfully');
        if (this.reg.documents && this.reg.documents.find(x => x.documentId === this.documentID)) {
          const matchedIndx = this.reg.documents.findIndex(x => x.documentId === this.documentID);
          this.reg.documents.splice(matchedIndx, 1);
          this.dataCollectionSvc.setRegistration(this.reg);
          this.dataCollectionSvc.sync(this.reg, this.reg.transactionId);
        } else {
          if (this.FileName) {
            this.FileName = null;
          }
        }
        this.alreadyHaveAttachmentForDocType = false;
        this.haveExistingAttachForTypeSubject.next(this.alreadyHaveAttachmentForDocType);
      });
  }

  getFileName() {
    if (this.reg.documents && this.reg.documents.find(x => x.documentType.code === this.documentTypeCode)) {
          this.enableUpload = true;
          return this.reg.documents.find(x => x.documentType.code === this.documentTypeCode).fileName;
    } else {
      if (this.FileName) {
        this.enableUpload = true;
      }
      return this.FileName;
    }
  }

}
